export const upsertCatalogOption = (items, saved) => {
  const index = items.findIndex(item => item.id === saved.id)
  if (index < 0) items.push(saved)
  else items.splice(index, 1, saved)
}
